<!--begin::Body-->
<div class="kt-login__body">
  <!--begin::Signin-->
  <div class="kt-login__form">
    <div class="kt-login__head kt-header__topbar">
      <!-- <span class="kt-login__signup-label">Don't have an account yet?</span>&nbsp;&nbsp;
      <a href="javascript:;" routerLink="/auth/register" class="kt-link kt-login__signup-link">{{ 'AUTH.GENERAL.SIGNUP_BUTTON' | transloco }}</a> -->
      <kt-language-selector></kt-language-selector>
    </div>

    <div class="kt-login__title">
      <img src="/assets/logo_oko.png" alt="Oko" />
      <h3>{{ 'AUTH.LOGIN.WELCOME' | transloco }}</h3>
    </div>

    <kt-auth-notice></kt-auth-notice>

    <!--begin::Form-->
    <form class="kt-form" [formGroup]="loginForm" autocomplete="off">
      <div class="form-group" [hidden]="needTfa">
        <mat-form-field>
          <mat-label>{{ 'AUTH.INPUT.EMAIL' | transloco }}</mat-label>
          <input
            matInput
            type="email"
            placeholder="{{ 'AUTH.INPUT.EMAIL' | transloco }}"
            formControlName="email"
            autocomplete="off"
          />
          <mat-error *ngIf="isControlHasError('email', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | transloco }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('email', 'email')">
            <strong>{{ 'AUTH.VALIDATION.INVALID_FIELD' | transloco }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('email', 'minlength')">
            <strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | transloco }} 3</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('email', 'maxlength')">
            <strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | transloco }} 320</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group" [hidden]="needTfa">
        <mat-form-field>
          <mat-label>{{ 'AUTH.INPUT.PASSWORD' | transloco }}</mat-label>

          <input
            matInput
            type="password"
            placeholder="{{ 'AUTH.INPUT.PASSWORD' | transloco }}"
            formControlName="password"
            readonly
            autocomplete="off"
            onfocus="this.removeAttribute('readonly');"
          />

          <mat-error *ngIf="isControlHasError('password', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | transloco }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'minlength')">
            <strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | transloco }} 3</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'maxlength')">
            <strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | transloco }} 100</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="form-group" [hidden]="!needTfa">
        <mat-form-field>
          <mat-label>{{ 'AUTH.INPUT.TFA_CODE' | transloco }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="{{ 'AUTH.INPUT.TFA_CODE' | transloco }}"
            formControlName="tfa"
            autocomplete="off"
          />
          <mat-hint>
            Open the two-factor authentication app on your device to view your authentication code and verify your
            identity.
          </mat-hint>
        </mat-form-field>
      </div>

      <!--begin::Action-->
      <div class="kt-login__actions">
        <a [routerLink]="['/', 'auth', 'forgot-password']" class="kt-link kt-login__link-forgot">
          {{ 'AUTH.GENERAL.FORGOT_BUTTON' | transloco }}
        </a>

        <button
          (click)="submit()"
          [ngClass]="{ 'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading }"
          id="kt_login_signin_submit"
          class="btn btn-primary btn-elevate kt-login__btn-primary"
        >
          {{ 'AUTH.LOGIN.BUTTON' | transloco }}
        </button>
      </div>
      <!--end::Action-->
    </form>
    <!--end::Form-->

    <!--begin::Divider-->
    <!-- <div class="kt-login__divider">
      <div class="kt-divider">
        <span></span>
        <span>OR</span>
        <span></span>
      </div>
    </div> -->
    <!--end::Divider-->

    <!--begin::Options-->
    <!-- <div class="kt-login__options">
      <a href="javascript:;" target="_blank" class="btn btn-primary kt-btn">
        <i class="fab fa-facebook-f"></i>
        Facebook
      </a>

      <a href="javascript:;" target="_blank" class="btn btn-info kt-btn">
        <i class="fab fa-twitter"></i>
        Twitter
      </a>

      <a href="javascript:;" class="btn btn-danger kt-btn">
        <i class="fab fa-google"></i>
        Google
      </a>
    </div> -->
    <!--end::Options-->
  </div>
  <!--end::Signin-->
</div>
<!--end::Body-->
